export const notificationKeys = {
  all: ['notifications'] as const,
  lists: () => [...notificationKeys.all, 'list'] as const,
  list: (options: NotificationOptions) => [...notificationKeys.lists(), { ...options }],
};
